import {Component, Injector} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {NewCertificationService} from "./services/new-certification.service";
import {AssociationService} from "../associactions/services/association.service";
import {ParameterService} from "../../_services/parameter.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-new-certification-list',
    templateUrl: './new-certification.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationComponent extends BasePageComponentDirective<any> {

    certifications: any[] = [];
    providers: any[] = [];
    attendanceTypes: any = {};

    showCloseSearch = false;

    constructor(
        injector: Injector,
        private certificationService: NewCertificationService,
        private associationService: AssociationService,
        private parameterService: ParameterService,
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.providers = await this.associationService.getAllNoPaging();
        this.query();
    }

    query(): void {
        this.tableLoading = true;
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['certificationTitle'];
        this.certificationService.getAll(this.pageQuery).then(r => {
            this.certifications = r.content;

            this.page.emit(r);
        });
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
            this.showCloseSearch = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.pageQuery.search = '';
        this.query();
        this.showCloseSearch = false;
    }

    addNewCertification() {
        this.router.navigate(['/office/new-certification/add-new']).then();
    }

    detailCertification(certificationId: number) {
        this.router.navigate(['/office/new-certification/detail', certificationId]).then();
    }

    deleteCertification(certificationId: number) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Delete Certification" ,
                subMessage: "Are you sure want to delete certification?",
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        })

        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.certificationService.deleteCertification(certificationId).then(_ => {
                    this.showAlertDark('Certification', 'Certification has been deleted successfully', '');
                    this.query();
                })

            }
        })
    }

    mergeAttendanceTypes(data: any[]) {
        return data.map(item => item.attendanceTypeLabel).join(", ");
    }
}
